<template>
  <div class="container-fluid p-0">
    <nav class="navbar navbar-light bg-light navbar-expand-xl shadow-sm py-0">
      <a class="navbar-brand order-0" href="#">
        <img src="@/assets/pckk-logo.png" class="logo" />
      </a>
      <button
        class="navbar-toggler ml-auto border-0 order-1"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <ul class="mb-0 pl-3 order-2 order-lg-3">
        <li class="nav-item" id="signout">
          <div class="dropdown">
            <button
              class="btn dropdown-toggle p-0"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img class="user" src="@/assets/user.jpg" />
            </button>
            <div
              class="dropdown-menu dropdown-menu-right p-0"
              aria-labelledby="dropdownMenuButton"
            >
              <div class="dropdown-item-text small text-muted p-2">
                {{ user && user.email }}
              </div>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <!-- <button
                v-if="userRole == 'Super Admin'"
                class="dropdown-item small text-light p-2"
                @click="goToUsers()"
              >
                <font-awesome-icon :icon="['fas', 'user-cog']" class="mr-2" />
                User list
              </button>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <button
                v-if="userRole == 'Super Admin'"
                class="dropdown-item small text-light p-2"
                @click="goToUserLogs()"
              >
                <font-awesome-icon :icon="['fas', 'user-cog']" class="mr-2" />
                User Access Logs
              </button>
              <router-link
                v-if="userRole == 'Super Admin'"
                class="dropdown-item small text-light p-2"
                :to="{ name: 'caseDeleteLogs' }"
              >
                <font-awesome-icon
                  :icon="['fas', 'calendar-times']"
                  class="mr-2"
                />
                Case Delete Logs
              </router-link>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <a
                href="https://cms.infrasel.co"
                target="_blank"
                class="dropdown-item text-light small p-2"
                v-if="user && user.isCmsUser"
              >
                <font-awesome-icon :icon="['fas', 'road']" class="mr-2" />
                Link to CMS
              </a>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <a
                href="https://apps.apple.com/us/app/ronda/id6444923451"
                target="_blank"
                class="dropdown-item text-light small p-2"
                v-if="user"
              >
                <font-awesome-icon
                  :icon="['fab', 'app-store-ios']"
                  class="mr-2"
                />
                iOS App Store
              </a>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <a
                href="https://play.google.com/store/apps/details?id=my.inference.infrasel.worker"
                target="_blank"
                class="dropdown-item text-light small p-2"
                v-if="user"
              >
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="mr-2"
                />
                Google Play Store
              </a> -->
              <div class="dropdown-divider border-top m-0"></div>
              <button
                class="dropdown-item small p-2"
                @click="showPasswordModal = true"
              >
                <font-awesome-icon :icon="['fas', 'key']" class="mr-2" />
                Change Password
              </button>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <button
                class="dropdown-item text-danger p-2"
                @click.prevent="logout()"
              >
                <font-awesome-icon
                  :icon="['fas', 'sign-out-alt']"
                  class="mr-2"
                /><small>Sign Out</small>
              </button>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="collapse navbar-collapse order-3 order-lg-2"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mr-auto">
          <li
            v-for="route in routes.filter(
              (route) =>
                !route.meta.roleRestricted ||
                (user && !route.meta.roleRestricted.includes(user.role.name))
            )"
            :key="route.name"
            class="nav-item justify-content-start justify-content-lg-center"
            :class="{
              active:
                $route.path == '/upload'
                  ? route.name == 'cases'
                  : isActiveNav(route.name),
            }"
          >
            <router-link
              class="nav-link stretched-link"
              :to="{ name: route.name }"
            >
              <span v-if="route.name === 'cases'">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                  <path
                    fill="currentColor"
                    d="M3 22q-.825 0-1.412-.587T1 20V9h2v11h17v2zm4-4q-.825 0-1.412-.587T5 16V5h5V3q0-.825.588-1.412T12 1h4q.825 0 1.413.588T18 3v2h5v11q0 .825-.587 1.413T21 18zm5-13h4V3h-4z"
                  />
                </svg>
              </span>
              <span v-if="route.name === 'gallery'">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                  <path
                    fill="currentColor"
                    d="M13.25 12.5L12.1 11q-.15-.175-.4-.175t-.4.175l-1.675 2.2q-.2.25-.063.525t.463.275h7.95q.325 0 .462-.275t-.062-.525l-2.425-3.175q-.15-.2-.4-.2t-.4.2l-1.9 2.475ZM8 18q-.825 0-1.413-.588T6 16V4q0-.825.588-1.413T8 2h12q.825 0 1.413.588T22 4v12q0 .825-.588 1.413T20 18H8Zm0-2h12V4H8v12Zm-4 6q-.825 0-1.413-.588T2 20V7q0-.425.288-.713T3 6q.425 0 .713.288T4 7v13h13q.425 0 .713.288T18 21q0 .425-.288.713T17 22H4ZM8 4v12V4Z"
                  />
                </svg>
              </span>
              <span v-if="route.name === 'defects'">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <!-- Icon from WeUI Icon by WeUI - undefined -->
                  <path
                    fill="currentColor"
                    fillRule="evenodd"
                    d="m21.268 21.053l-18.536.001a1 1 0 0 1-.866-1.5L11.132 3.5a1 1 0 0 1 1.732 0l9.27 16.053a1 1 0 0 1-.866 1.5M11.248 9.545l.116 5.666h1.272l.117-5.666zm.75 8.572c.48 0 .855-.369.855-.832s-.375-.826-.856-.826a.83.83 0 0 0-.85.826c0 .463.375.832.85.832z"
                  />
                </svg>
              </span>
              <span v-if="route.name === 'reports'">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                >
                  <!-- Icon from Lsicon by Wis Design - https://github.com/wisdesignsystem/lsicon/blob/main/LICENSE -->
                  <path
                    fill="currentColor"
                    fillRule="evenodd"
                    d="M2.5 1.045a.5.5 0 0 0-.5.5v10.91a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V5.364a.5.5 0 0 0-.152-.36L7.911 1.188a.5.5 0 0 0-.348-.142zm7.766 3.819L8.063 2.727v2.137zM6 5.5H4v-1h2zM10 8H4V7h6zm-6 2.5h6v-1H4z"
                    clipRule="evenodd"
                  />
                  <path
                    fill="currentColor"
                    d="M13 7.5V14H4.5v1h9a.5.5 0 0 0 .5-.5v-7z"
                  /></svg
              ></span>
              <span v-if="route.name === 'dashcam'">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                  <path
                    fill="currentColor"
                    d="M6 16h8v-3.2l4 3.2V8l-4 3.2V8H6zm-2 4q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20z"
                  />
                </svg>
              </span>

              <span v-if="route.name === 'drone'">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                  <path
                    fill="currentColor"
                    d="M4 20q0-1.875 1.025-3.363t2.65-2.162L7.425 12H4V6H1V4h8v2H6v4h1.2L7 8h10l-.2 2H18V6h-3V4h8.025v2h-3v6H16.6l-.25 2.475q1.625.675 2.638 2.163T20 20h-2q0-1.65-1.175-2.825T14 16h-4q-1.65 0-2.825 1.175T6 20z"
                  />
                </svg>
                <!-- <font-awesome-icon :icon="route.icon" /> -->
              </span>
              <span v-if="route.label">{{ route.label }}</span>
              <span class="text-capitalize" v-else>{{ route.name }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
    <slot />
    <change-password-modal
      :show="showPasswordModal"
      @close="showPasswordModal = false"
    />
  </div>
</template>

<script>
import { routes } from "@/router/routes";
import ChangePasswordModal from "../modals/ChangePassword";

export default {
  components: {
    ChangePasswordModal,
  },
  data() {
    return {
      user: null,
      userRole: null,
      showPasswordModal: false,
      routes: routes.filter((route) => route.meta?.showInNavbar),
    };
  },
  methods: {
    goToUsers() {
      this.$router.push({
        name: "users",
      });
    },
    goToUserLogs() {
      this.$router.push({
        name: "logs",
      });
    },
    isActiveNav(name) {
      return this.$route.name == name;
    },
    logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.$router.push({
        name: "auth",
      });
    },
  },
  mounted() {
    let _user = localStorage.getItem("user");

    if (_user) {
      this.user = JSON.parse(_user);
      this.userRole = JSON.parse(_user).role.name;
    }
  },
};
</script>
